import { ProjectPaperLayout } from "app/areas/projects/components/ProjectPaperLayout";
import * as React from "react";
import type { PaperLayoutVNextProps } from "~/components/PaperLayout/PaperLayoutVNext";
export const ProjectContextPaperLayout: React.FC<PaperLayoutVNextProps> = ({ children, ...rest }) => <ProjectPaperLayout {...rest}>{children}</ProjectPaperLayout>;
ProjectContextPaperLayout.displayName = "ProjectContextPaperLayout"
